import { email as emailRegex } from '../regex'

const DEFAULT_EMAIL_MESSAGE = 'Provide a valid email address'
const DEFAULT_EMAIL_LOCAL_PART_MESSAGE = "Provide a valid email's local part"
const DEFAULT_EMAIL_DISPLAY_NAME_MESSAGE = "Provide a valid email's display name"

const email = (value) => {
  if (value && !emailRegex.test(value)) {
    return DEFAULT_EMAIL_MESSAGE
  }
}

const emailLocalPartRegExp = new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+$/)

export const emailLocalPart = (value) => {
  if (value && !emailLocalPartRegExp.test(value)) {
    return DEFAULT_EMAIL_LOCAL_PART_MESSAGE
  }
}

const emailDisplayNameRegExp = new RegExp(/^[\p{L}\d\s\-._]+$/u)

export const emailDisplayName = (value) => {
  if (value && !emailDisplayNameRegExp.test(value)) {
    return DEFAULT_EMAIL_DISPLAY_NAME_MESSAGE
  }
}

export default email
